import { useMemo } from 'react';
import { useGetUserVoucherOnboardingQuery } from '../services/benefitApi';
import { computeShouldShowBenefitsOnboardingEntry, ContractStatus, VOUCHER_ONBOARDING_PLATFORM_IBK, VOUCHER_ONBOARDING_TYPE_WELCOME, } from '../types';
export function useBenefitsOnboardingEntry({ contract, enabled, isEligible, platform = VOUCHER_ONBOARDING_PLATFORM_IBK, }) {
    const hasActive = contract.status === ContractStatus.ACTIVE;
    const skipQuery = !enabled || !hasActive || !isEligible;
    const { data, isError, isLoading, isFetching, isUninitialized } = useGetUserVoucherOnboardingQuery({ platform, type: VOUCHER_ONBOARDING_TYPE_WELCOME }, { skip: skipQuery });
    const shouldShowOnboardingEntry = useMemo(() => computeShouldShowBenefitsOnboardingEntry({
        enabled,
        hasActiveContract: hasActive,
        isEligible,
        isQuerySkipped: skipQuery,
        isQueryError: isError,
        isQueryLoading: isLoading,
        isQueryFetching: isFetching,
        isQueryUninitialized: isUninitialized,
        onboardingItems: data,
    }), [enabled, hasActive, isEligible, skipQuery, isError, isLoading, isFetching, isUninitialized, data]);
    return { shouldShowOnboardingEntry };
}
